const ALIDA_JWT_PREFIX = 'alidaJwt=';

/**
 * Extracts the Hubs JWT token from a cookie string.
 * @param cookie - The jwt cookie value as a string, typically in the format "ey...n|alidaJwt=ey..."
 * @returns An extracted Hubs JWT token
 */
export const parseHubsJWTFromCookie = (cookie: string) => {
	return cookie.split('|')[0];
};

/**
 * Extracts the alida JWT token from a cookie string.
 * @param cookie - The jwt cookie value as a string, typically in the format "ey...n|alidaJwt=ey..."
 * @returns An extracted alida JWT token if present, otherwise an empty string.
 */
export const parseAlidaJWTFromCookie = (cookie: string) => {
	const parts = cookie.split('|');

	if (parts.length > 1 && parts[1].startsWith(ALIDA_JWT_PREFIX)) {
		return parts[1].substring(ALIDA_JWT_PREFIX.length); // Remove 'alidaJwt=' prefix
	}

	return '';
};
